export default [
  {
    path: "dias-libres",
    name: "monitoring-dias-libres",
    component: () =>
      import(
        /* webpackChunkName: "MonitoringDiasLibres" */ "@/views/monitoring/views/dias-libres/DiasLibresReport.vue"
      ),
    meta: {
      section: 60,
      pageTitle: "Días Libres",
      breadcrumb: [
        {
          text: "Reporte",
          active: true,
        },
      ],
    },
  },
];
